import { configureStore } from '@reduxjs/toolkit';
import authSlice from './auth/authSlice';
import userReducer from './user/userReducer';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    user: userReducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export default store;
